export default {
    init() {
      // JavaScript to be fired on all pages
        window.that = this;
        jQuery('select.image-picker').imagepicker({
            show_label: true,
            limit: 3,
        });

        jQuery('.dropdown-toggle').click(function () {
            if ($(window).width() > 991.99) {
                window.location.href = jQuery(this).attr('href');
            }

            return false;
        });

        jQuery(function () {
            $('[data-toggle="tooltip"]').tooltip({
                boundary: 'window',
                html: true,
            })
        });

        jQuery('form.color-swatches-form .fabric-colors > select').on('change', function () {
            let selectedOptions = $(this).val();
            if (selectedOptions.length > 0) {
                jQuery('#add_to_cart_button').prop('disabled', false);
            } else {
                jQuery('#add_to_cart_button').prop('disabled', true);
            }
        });

        jQuery('form.customizer-form select#customizer_shapes').on('change', this.updateCustomizerFillings);
        jQuery('form.customizer-form select#customizer_shapes').on('change', this.updateCustomizerSizes);
        jQuery('form.customizer-form select#customizer_shapes').on('change', this.updateCustomizerFinishes);
        jQuery('form.customizer-form select#customizer_shapes').on('change', function () {
            if ($(this).val() === null) {
                jQuery('.no-shape-notice').show();
            } else {
                jQuery('.no-shape-notice').hide();
            }
        });

        jQuery('input[type=radio][name=fabric_category]').on('change', this.updateCustomizerFabricCategories);
        jQuery('form.customizer-form').on('submit', this.submitCustomizerForm);
        jQuery('form.color-swatches-form').on('submit', this.submitColorSwatchesForm);

        jQuery('form.customizer-form select, input').on('change', this.updatePrice);
        jQuery('form.customizer-form #add_to_cart_alert').on('close.bs.alert', function () {
            $(this).removeClass('show');
            return false;
        });
    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
        jQuery(document).ready(function () {
            let newUrl = new URL(window.location.href);
            let data = atob(newUrl.searchParams.get('hash'));
            if (data) {
                data = JSON.parse(data);
                jQuery(`input#fabric_${data.fabric_category}`).prop('checked', true);
                jQuery('#customizer_shapes').val(data.shape).change();

                jQuery('.fabric-colors').removeClass('active');
                jQuery(`.fabric-${data.fabric_category}-colors`).addClass('active');

                let fabricOption = jQuery(`#fabric-${data.fabric_category}-colors-select option[data-subcategory=${data.fabric_subcategory}][data-color=${data.fabric_subcategory_color}]`);
                fabricOption.attr('selected', true);
                jQuery(`#fabric-${data.fabric_category}-colors-select`).data('picker').sync_picker_with_select();

                let fillingOption = jQuery(`.shape-${data.shape}-fillings select > option[data-shape=${data.shape}][data-filling=${data.filling}]`);
                fillingOption.attr('selected', true);
                jQuery(`.shape-${data.shape}-fillings select`).data('picker').sync_picker_with_select();

                Object.keys(data.size).forEach(function (key,index) {
                    let realKey = Object.keys(data.size[index])[0];
                    let value = data.size[index][realKey];
                    jQuery(`.shape-${data.shape}-sizes input[data-key=${realKey}]`).val(value);
                });

                jQuery(`.shape-${data.shape}-sizes select#zipper_options`).val(data.zipper_options);
                jQuery('#product_quantity').val(data.quantity);

                jQuery('select#finishes_select').val(data.finish);
                jQuery('select#finishes_select').data('picker').sync_picker_with_select();

                window.that.updatePrice(false);
            }
        });
    },
    updateCustomizerFillings() {
        let optionSelected = $('option:selected', this);
        let shapeId = optionSelected.data('shape');
        jQuery('.shape-fillings').removeClass('active');
        jQuery('.shape-' + shapeId + '-fillings').addClass('active');

        jQuery('.shape-finishes').removeClass('active');
        jQuery('.shape-finishes').addClass('active');
    },
    updateCustomizerFabricCategories() {
        jQuery('.fabric-colors > select.image-picker').each(function () {
            jQuery(this).val([]);
            jQuery(this).data('picker').sync_picker_with_select();
        });

        jQuery('.fabric-colors').removeClass('active');
        jQuery('.fabric-' + jQuery(this).data('fabric') + '-colors').addClass('active');
        let select = jQuery('.fabric-' + jQuery(this).data('fabric') + '-colors.active > select.image-picker');
        let options = select[0].options;
        if(options.length < 3)
        {
          jQuery(select).val(options[1].value);
          jQuery(select).data('picker').sync_picker_with_select();
        }

    },
    updateCustomizerSizes() {
        let optionSelected = jQuery('option:selected', this);
        let shapeId = optionSelected.data('shape');
        jQuery('.shape-sizes').removeClass('active');
        jQuery('.shape-' + shapeId + '-sizes').addClass('active');

        jQuery('.shape-sizes select, .shape-sizes input').prop('required', false);
        jQuery('.shape-' + shapeId + '-sizes input, .shape-' + shapeId + '-sizes select').prop('required', true);
    },

    updateCustomizerFinishes() {
        let optionSelected = jQuery('option:selected', this);
        let shapeFinish = optionSelected.data('finish').split(',');
        let finishes = document.querySelectorAll('#finishes_select option');
        let finishItem = document.querySelector('#finishes_select').parentNode.querySelectorAll('.thumbnails li');

        finishes.forEach((finish, index) => {
            let finishValue = finish.dataset.name;
            let x = finishItem[index - 1];

            if (shapeFinish.includes(finishValue)) {
                if (x) {
                    x.classList.add('active');
                }
            } else {
                if (x) {
                    x.classList.remove('active');
                }
            }
        });
    },

    updatePrice(updateUrl = true) {
        jQuery.post(jQuery('form.customizer-form').attr('action'), window.that.getCustomizerData('get_customized_price'), function (data) {
            if (data.success) {
                let newPrice = String(data.price.total).replace('.', ',');
                jQuery('.total-price > span.price').text(newPrice);
                jQuery('#add_to_cart_button').prop('disabled', false);
                if (updateUrl) {
                    window.that.updateUrl();
                }
            } else {
                jQuery('.total-price > span.price').text('--,-');
                jQuery('#add_to_cart_button').prop('disabled', true);
            }
        });
    },
    updateUrl() {
        let data = window.that.getCustomizerData('get_customized_price', true);
        let newUrl = new URL(window.location.href);
        newUrl.searchParams.set('hash', btoa(JSON.stringify(data)));
        window.history.replaceState(null, document.title, newUrl.href);
    },
    submitCustomizerForm(e) {
        e.preventDefault();
        jQuery.post(jQuery('form.customizer-form').attr('action'), window.that.getCustomizerData('add_customized_product'), function (data) {
            if (data.success) {
                jQuery('#add_to_cart_alert').toggleClass('show');
            } else {
                alert('Er is een fout opgetreden tijdens het toevoegen van uw product aan de winkelmand. Probeer het later opnieuw.')
            }
        });
    },
    submitColorSwatchesForm(e) {
        e.preventDefault();

        let fabricColors = [];
        jQuery('option:selected', jQuery('.fabric-colors.active > select')).each(function (key, item) {
            let categoryName = jQuery(this).parent('optgroup').prev().attr('label');
            let subcategoryName = jQuery(this).parent('optgroup').attr('label');
            let colorName = item.innerText.trim();

            fabricColors.push(`${categoryName} ${subcategoryName} ${colorName}`);
        });

        jQuery.post(jQuery('form.color-swatches-form').attr('action'), {
            colors: fabricColors,
            _wpnonce: jQuery('#_wpnonce_add_color_swatch_product').val(),
            action: 'add_color_swatch_product',
        }, function (data) {
            if (data.success) {
                window.location.href = data.redirect_url;
            } else {
                alert('Er is een fout opgetreden tijdens het toevoegen van uw product aan de winkelmand. Probeer het later opnieuw.')
            }
        });
    },

    getCustomizerData(action, simple = false) {
        let data = {
            shape: 0,
            fabric_category: 0,
            fabric_subcategory: 0,
            fabric_subcategory_color: 0,
            filling: 0,
            finish: 0,
            size: [],
            zipper_options: '',
            quantity: 0,
        };

        data.shape = jQuery('#customizer_shapes').val();
        data.fabric_category = jQuery('input[name="fabric_category"]:checked').data('fabric');

        let fabricColorOption = jQuery('option:selected', jQuery('.fabric-colors.active > select'));
        data.fabric_subcategory = fabricColorOption.data('subcategory');
        data.fabric_subcategory_color = fabricColorOption.data('color');

        let fillingOption = jQuery('option:selected', jQuery('.shape-fillings.active select'));
        data.filling = fillingOption.data('filling');

        jQuery('.shape-sizes.active input').each(function () {
            data.size.push({[jQuery(this).data('key')]: jQuery(this).val()})
        });

        data.zipper_options = jQuery('.shape-sizes.active #zipper_options').val();
        data.quantity = jQuery('#product_quantity').val();
        data.finish = jQuery('#finishes_select').val();

        if (!simple) {
            data._wpnonce = jQuery('input[name=_wpnonce_' + action + ']').val();
            data._wp_http_referer = jQuery('input[name=_wp_http_referer]').val();
            data.action = action;
        }

        return data;
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js